import { render } from "./VGlace.vue?vue&type=template&id=70f91ec2"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VGlace.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70f91ec2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70f91ec2', __exports__)) {
    api.reload('70f91ec2', __exports__)
  }
  
  module.hot.accept("./VGlace.vue?vue&type=template&id=70f91ec2", () => {
    api.rerender('70f91ec2', render)
  })

}


export default __exports__